import React from "react";
import {useDispatch, useSelector} from "react-redux";
import _ from "lodash";
import classNames from "classnames";
import Info from "./Info";
import Error from "./Error";
import {useForm} from "ui-components-rollup/dist/Forms";
import cvsInfo from '../../../utils/cvsInfo'
import { ReactComponent as InlineLoader } from "ui-components-rollup/src/images/loaders/inline-loader.svg";
import commonStyles from "../../../styles/common.module.scss";
import styles from "./Content.module.scss";

export default ({ flavour }) => {
    const dispatch = useDispatch();
    const { initialState, validator, form: Form, formTitle } = cvsInfo[flavour];
    const { handleFormSubmit, formState, ...fromProps } = useForm(initialState, validator);
    const submitError = useSelector(state => _.get(state, "cvs2.credentialsError"));
    const credentialsFormSubmitPending = useSelector(state => _.get(state, "cvs2.credentialsFormSubmitPending"));
    const onFormSubmit = () => {
        if (formState.region) {
            formState.region = formState.region.value;
        }
        if (formState.project) {
            formState.project = formState.project.value;
        }
        dispatch({
            type: "CVS2:SUBMIT-CREDENTIALS",
            payload: { ...formState, provider: flavour }
        });
    };
    return (
        <div className={styles["container"]}>
            <main className={styles["main-content-container"]}>
                <div className={styles["content"]}>
                    <div className={styles["from-container"]}>
                        <div className={classNames(commonStyles["title"], styles["title"])}>{formTitle}</div>
                        <Form handleFormSubmit={handleFormSubmit} onFormSubmit={onFormSubmit} formState={formState} {...fromProps}/>
                    </div>
                    <Info flavour={flavour}/>
                </div>
                { submitError &&  <Error flavour={flavour}/>}
            </main>
            <footer>
                { credentialsFormSubmitPending
                    ? <InlineLoader className={classNames(commonStyles["inline-loader"], styles["loader"])}/>
                    : <button onClick={handleFormSubmit(onFormSubmit)} className={commonStyles["primary-button"]}>Submit</button>
                }
            </footer>
        </div>
    );
};
